import { render, staticRenderFns } from "./OrganisationRelationsList.vue?vue&type=template&id=7f99b3a8"
import script from "./OrganisationRelationsList.vue?vue&type=script&lang=js"
export * from "./OrganisationRelationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports